<div class="grid justify-content-center">
  <div class="col-12 align-items-center justify-content-center">
    <div class="card">
      <h5 class="m-0">{{ settings.title }}</h5>
      <br />
      <p-progressBar *ngIf="listingData" mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
      <p-table #dt [resizableColumns]="true" [value]="data" [columns]="selectedColumns" [paginator]="true" [rows]="rows"
        [rowsPerPageOptions]="[10, 20, 30]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [lazy]="isServerSide"
        [totalRecords]="isServerSide ? (settings?.totalRecords || 0) : localTotalRecords"
        (onLazyLoad)="isServerSide && onLazyLoad($event)" selectionMode="single" [rowHover]="true" dataKey="id"
        [responsive]="true" columnResizeMode="expand" [reorderableColumns]="true"
        styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm">


        <ng-template pTemplate="caption">
          <div class="flex md:justify-content-between md:align-items-center mt-2">
            <div *ngIf="showSearchHelpers" class="flex align-items-center justify-content-center">
              <p-multiSelect [options]="settings.columns" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columnas seleccionadas" [style]="{ width: '100%' }"
                placeholder="Filtrar Columna" class="mt-0 mb-2 md:mt-0"></p-multiSelect>
              <span class="block ml-3 mb-2 p-input-icon-left w-24rem">
                <i class="pi pi-search"></i>
                <input style="width: 100%" pInputText type="text"
                  (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
              </span>
            </div>
            <div class="flex align-items-center justify-content-center mb-2">
              <ng-container *ngIf="settings.exportData">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                  class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                  class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
              </ng-container>
              <ng-container *ngIf="actionsHead">
                <div *ngFor="let actionHead of actionsHead">
                  <button pButton pRipple [icon]="actionHead.icon" [class]="actionHead.class"
                    (click)="actionHeadRow(actionHead)" [pTooltip]="actionHead.pTooltip"
                    tooltipPosition="left"></button>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of selectedColumns" pSortableColumn="{{ col.field }}">
              {{ col.header }}
              <p-sortIcon field="{{ col.field }}"></p-sortIcon>
            </th>
            <th *ngFor="let action of actions"></th>
          </tr>
          <tr *ngIf="settings.filterColumns">
            <th *ngFor="let col of selectedColumns">
              <input id="filterColumn" pInputText style="width: 75%; max-width: 75%" type="text"
                (input)="dt.filter(transformDateInput($event.target.value, col.header), col.field, 'contains')" />
            </th>
            <th *ngFor="let action of actions"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData" [ngClass]="{ 'row-priceless': rowData.statusPriceId == '1' }">
            <td *ngFor="let col of selectedColumns; let i = index">
              <span class="p-column-title">{{ col.header }} </span>
              <p [ngClass]="{
    'negative-cell': isNegativeSaldo(col.field, rowData[col.field])
  }" [title]="col.tooltipField ? rowData[col.tooltipField] : ''" *ngIf="
                  selectedColumns[i].pipe !== 'Uppercase' &&
                  selectedColumns[i].pipe !== 'Currency' &&
                  selectedColumns[i].pipe !== 'Date' &&
                  selectedColumns[i].pipe !== 'Percent' &&
                  selectedColumns[i].pipe !== 'Boolean' &&
                  selectedColumns[i].tag !== 'tagStatus' &&
                  selectedColumns[i].tag !== 'tagPaymentMethod'
                ">
                {{ rowData[col.field] }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Uppercase'">
                {{ rowData[col.field] | uppercase }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Currency'">
                {{ rowData[col.field] | currency: 'PEN' }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Date'">
                {{ rowData[col.field] | date: 'shortDate' }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Percent'">
                {{ rowData[col.field] | percent: '2.0-2' }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Boolean'">
                <i [ngClass]="
                    rowData[col.field] === true ? 'pi pi-check' : 'pi pi-times'
                  " style="font-size: 2rem"></i>
              </p>
              <p-tag *ngIf="selectedColumns[i].tag === 'tagStatus'" [style]="{ background: rowData['tagStatusColor'] }"
                [severity]="rowData['statusTag']">
                {{ rowData[col.field] }}
              </p-tag>
              <p-tag *ngIf="selectedColumns[i].tag === 'tagPaymentMethod'"
                [style]="{ background: rowData['tagPaymentMethodColor'] }">
                {{ rowData[col.field] }}
              </p-tag>
            </td>
            <td *ngFor="let action of actions">
              <div class="flex justify-content-center" *ngIf="!action.visible || action.visible(rowData)">
                <div class="flex align-items-center justify-content-center">
                  <button pButton pRipple [icon]="action.icon" [class]="action.class"
                    (click)="actionRow(action, rowData)" [pTooltip]="action.pTooltip" tooltipPosition="left"></button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
